module.exports = __webpack_public_path__ + "static/img/三层.887da48.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/三层.png
// module id = kGoc
// module chunks = 0